<template>
  <v-navigation-drawer
    class="list_items"
    color="white"
    v-model="drawerComputed"
    :mini-variant.sync="mini"
    permanent
  >
    <!-- top list -->
    <v-list-item class="d-flex flex-column">
      <v-list-item-content class="elevation-0">
        <v-btn
          color="white"
          v-if="mini"
          @click.stop="mini = !mini"
          class="w-100"
          elevation="0"
        >
          <v-icon size="22" class="ml-2">mdi-list-box-outline</v-icon>
        </v-btn>
        <v-btn v-else @click.stop="mini = !mini" class="w-100" elevation="0">
          بستن منو
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-btn v-if="mini" class="w-100" color="white" elevation="0">
          <v-icon>mdi-forum-plus</v-icon>
        </v-btn>
        <v-btn @click="$emit('reset')" v-else class="w-100" elevation="0">
          چت جدید
          <v-icon>mdi-forum-plus</v-icon>
        </v-btn>
      </v-list-item-content>
    </v-list-item>

    <!-- list chat -->
    <template v-if="!mini">
      <v-list v-for="(keys, i) in Object?.keys(archive)" :key="i" dense nav>
        <v-subheader>{{ keys }}</v-subheader>
        <v-list-item v-for="item in archive[keys]" :key="item.id" link>
          <v-list-item-icon>
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-list-item-icon>

          <v-list-item-content
            @click="
              $emit('click', item.id, item.model);
              mini = true;
            "
          >
            <v-list-item-title>
              {{ item?.title ?? "مکالمه سابق" }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <template v-else></template>
  </v-navigation-drawer>
</template>

<script>
import ChatServices from "../../../../utilities/ChatServices";
import moment from "moment";

export default {
  name: "listChatBot",
  props: { value: Boolean },

  data() {
    return {
      chatServices: null,
      loading: false,
      test: true,
      mini: true,
    };
  },

  computed: {
    drawerComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", !val);
      },
    },
    mobile() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },

  mounted() {
    this.chatServices = new ChatServices();
    this.getArchive();
  },

  methods: {
    async getArchive() {
      this.loading = true;
      try {
        const { data } = await this.chatServices.getAllArchiveChats();
        this.checkTime(data.data);
      } catch {
      } finally {
        this.loading = false;
      }
    },

    checkTime(data) {
      const today = moment().startOf("day");
      const yesterday = moment().subtract(1, "day").startOf("day");
      const lastWeek = moment().subtract(7, "days").startOf("day");
      const lastMonth = moment().subtract(1, "month").startOf("day");

      const times = {
        today: [],
        yesterday: [],
        lastWeek: [],
        lastMonth: [],
        older: [],
      };

      data.forEach((item) => {
        const dateStr = item.created_at;
        const date = moment(dateStr);
        if (date.isSame(today, "day")) {
          times.today.push(item);
        } else if (date.isSame(yesterday, "day")) {
          times.yesterday.push(item);
        } else if (date.isAfter(lastWeek)) {
          times.lastWeek.push(item);
        } else if (date.isAfter(lastMonth)) {
          times.lastMonth.push(item);
        } else {
          times.older.push(item);
        }
      });

      let filtersTimess = {};
      Object.keys(times).map((item) => {
        if (times[item]?.length > 0) {
          filtersTimess = { ...filtersTimess, [item]: times[item] };
        }
      });

      this.archive = filtersTimess;
    },
  },

  watch: {
    mini(val) {
      this.drawerComputed = val;
    },
  },
};
</script>

<style scoped>
.list_items {
  background: white;
}
.v-list-item::after {
  display: none;
}
</style>
